import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
interface Props {
  data: string[]
  title?: string
}
export const RelatedLinks = ({ data, title = 'Artikel zum Thema' }: Props) => {
  return (
    <div className='relatedLinks'>
      <div className='title'>{title}:</div>
      {data.map((link, i) => {
        const d = link.split('[')
        if (d[0].length <= 0) return <div key={i} />
        return (
          <Link
            key={i}
            href={d[1].replace(
              'tagesanzeiger.ch',
              parseHostname().publicationDomain
            )}
            icon='caret right'
          >
            {d[0]}
          </Link>
        )
      })}
    </div>
  )
}
